// Copyright (C) 2021 Bystronic Laser AG

export enum CutLayoutTab {
  CutOverview,
  CutCurrentWorkload,
  CutIntradayStates,
  CutTrends,
}
